/* eslint-disable react-hooks/exhaustive-deps */
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./assets/css/App.css";
import "./assets/css/titleCase.css";
import "./assets/css/clubStaffPageShell.css";
import "./assets/css/mobileResponsive.css";
import ToastComponent from "./components/toastComponent/toastComponent";
import VerticalLayout from "./components/verticalLayout";
import {
  authProtectedRoutes,
  clubStaffRoutes,
  organiserRoutes,
  publicRoutes,
} from "./routes";

import { useSelector } from "react-redux";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ProtectedClubStaffRoute from "./components/ProtectedClubStaffRoute";
import ProtectedOrganiserRoute from "./components/ProtectedOrganiserRoute";
import ClubManagerOnly from "./components/ClubManagerOnly";
import Constant from "./util/constant";
import TableBookingBookings from "./pages/tableBooking/TableBookingBookings";
import TableBookingClubPicker from "./pages/tableBooking/TableBookingClubPicker";
import TableBookingLayoutEditor from "./pages/tableBooking/TableBookingLayoutEditor";
import TableBookingLayoutsList from "./pages/tableBooking/TableBookingLayoutsList";
import TableBookingShell from "./pages/tableBooking/TableBookingShell";

/** Nested routes under a pathless layout must not use a leading slash. */
function nestRoutePath(path) {
  const p = String(path || "").trim();
  return p.startsWith("/") ? p.slice(1) : p;
}

function App() {
  const loginResponse = useSelector((state) => state?.auth?.loginResponse);
  const reduxRole =
    loginResponse &&
    typeof loginResponse === "object" &&
    !Array.isArray(loginResponse)
      ? loginResponse.role
      : "";
  const role = reduxRole || window.localStorage.getItem("role") || "";
  // if (role) {
  //   if (role === Constant.ROLES.ADMIN) {
  //     return <Navigate to="/users-management" />;
  //   } else if (role === Constant.ROLES.ORGANISER) {
  //     return <Navigate to="/events-list" />;
  //   }
  // }
  return (
    <React.Fragment>
      <ToastComponent />
      <Routes>
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}

        <Route element={<VerticalLayout />}>
          {(role === Constant.ROLES.ADMIN ||
            window.localStorage.getItem("role") === Constant.ROLES.ADMIN) && (
            <Route element={<ProtectedAdminRoute />}>
              {authProtectedRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={nestRoutePath(route.path)}
                  element={route.element}
                />
              ))}
              <Route
                path="clubs-table-booking"
                element={<TableBookingClubPicker />}
              />
              <Route
                path="clubs/:clubId/table-booking"
                element={<TableBookingShell />}
              >
                <Route
                  index
                  element={<Navigate to="layouts" replace />}
                />
                <Route
                  path="layouts"
                  element={<TableBookingLayoutsList />}
                />
                <Route
                  path="layouts/:layoutId"
                  element={<TableBookingLayoutEditor />}
                />
                <Route
                  path="bookings"
                  element={<TableBookingBookings />}
                />
              </Route>
            </Route>
          )}
          {(role === Constant.ROLES.ORGANISER ||
            window.localStorage.getItem("role") ===
              Constant.ROLES.ORGANISER) && (
            <Route element={<ProtectedOrganiserRoute />}>
              {organiserRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={nestRoutePath(route.path)}
                  element={route.element}
                />
              ))}
            </Route>
          )}
          {((role === Constant.ROLES.CLUB_MANAGER ||
            role === Constant.ROLES.CLUB_EMPLOYEE ||
            window.localStorage.getItem("role") ===
              Constant.ROLES.CLUB_MANAGER ||
            window.localStorage.getItem("role") ===
              Constant.ROLES.CLUB_EMPLOYEE) && (
            <Route element={<ProtectedClubStaffRoute />}>
              {clubStaffRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={nestRoutePath(route.path)}
                  element={route.element}
                />
              ))}
              <Route
                path="club-table-booking"
                element={
                  <ClubManagerOnly>
                    <TableBookingClubPicker />
                  </ClubManagerOnly>
                }
              />
              <Route
                path="clubs/:clubId/table-booking"
                element={
                  <ClubManagerOnly>
                    <TableBookingShell />
                  </ClubManagerOnly>
                }
              >
                <Route
                  index
                  element={<Navigate to="layouts" replace />}
                />
                <Route
                  path="layouts"
                  element={<TableBookingLayoutsList />}
                />
                <Route
                  path="layouts/:layoutId"
                  element={<TableBookingLayoutEditor />}
                />
                <Route
                  path="bookings"
                  element={<TableBookingBookings />}
                />
              </Route>
            </Route>
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
}

export default App;
